/* eslint-disable */
export default {
  topic: '会議タイトル',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
